
import { computed, defineComponent } from 'vue';
export default defineComponent({
  name: 'TypeItem',
  props: ['item', 'name'],
  emits: ['jumpFanPage', 'getGift', 'fbHasClick'],
  setup(props: any, { emit }) {
    const canGet = computed(() => {
      return !props.item.isReward && props.item.isClickFanBtn;
    });
    const hasGet = computed(() => {
      return props.item.isReward;
    });
    const jumpFanPage = (plat) => {
      emit('jumpFanPage', plat);
    };
    const getGift = (name) => {
      emit('getGift', name);
    };
    return {
      jumpFanPage,
      getGift,
      canGet,
      hasGet,
    };
  },
});
